import { PriceStatus } from '@toggle/helpers';
import styled from 'styled-components';

import { priceChangeColors } from '~/utils/common/utils';

export const NumberTableValue = styled.span<{ $status: PriceStatus }>`
  display: flex;
  align-items: center;
  height: 100%;
  padding-left: 8px;
  font-family: var(--font-roboto-mono);
  color: ${({ $status }) => priceChangeColors[$status]};
  text-align: right;
`;
